import { render, staticRenderFns } from "./_PageSubMenuDuplicates.vue?vue&type=template&id=6b3c5e20&"
import script from "./_PageSubMenuDuplicates.vue?vue&type=script&lang=js&"
export * from "./_PageSubMenuDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports